<style scoped>
  .box1 {
    background: white;
    border-radius: 5px;
    margin-right: 20px;
    padding: 20px;
    border: 1px solid #eee;
  }

  /*html {*/
  /*background: url(images/bg.jpg) no-repeat center center fixed;*/
  /*-webkit-background-size: cover;*/
  /*-moz-background-size: cover;*/
  /*-o-background-size: cover;*/
  /*background-size: cover;*/
  /*}*/

  .bg {
    /*position: fixed;*/
    /*top: 0;*/
    /*left: 0;*/
    /*bottom: 0;*/
    /*right: 0;*/
    /*overflow: auto;*/
    min-height: 100%;
    /*height: 100vh;*/
    /*background-color: dimgray;*/
    background-image: url("../../assets/bglogin.jpg");
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }

  .container {
    position: absolute;
    top: 50%;
    left: 50%;
    -moz-transform: translateX(-50%) translateY(-55%);
    -webkit-transform: translateX(-50%) translateY(-55%);
    transform: translateX(-50%) translateY(-55%);
    /*border: 1px solid indianred;*/
    opacity: 0.7;
    background-color: #39317e;
    width: 420px;
    height: 320px;
    border-radius: 20px;
  }

  .shad {
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  }

  /*div {*/
    /*border: 1px solid indianred;*/
  /*}*/

  a:hover {
    color: azure;
    text-decoration: underline;
  }

  a {
    color: azure;
  }

  .container {
    --color-text-light: #ffffff;
    --color-text: #e6e6e6;
    --color-text-dark: #787bb4;
    --color-input: #2a2f44;
    --color-input-shadow: rgba(255, 255, 255, 0.2);
    --color-neutral-light: #cbcbcb;
  }

  /*.mob {*/
  /*  width: 320px;*/
  /*}*/
</style>
<template>
  <div class="bg" style="text-align: center;">
    <img alt=""
         src="@/assets/logo.png"
         style="width: 160px; margin-top: 20px;">
<!--    <div class="container box shad" style="padding: 20px; font-size: 16px;" :class="{ mob : mobile }" v-if="mobile">-->
<!--      <span v-if="$route.params.ctok">Благодарим за регистрацию на платформе Capico<br><br></span>-->
<!--      На данный момент доступна только десктопная версия сайта.<br>-->
<!--      Адаптация под мобильные устройства появится позже-->
<!--    </div>-->
    <div class="container box shad" style="padding: 20px;" v-if="$route.params.ctok === undefined">
<!--    <div class="container box shad" style="padding: 20px;" v-else-if="$route.params.ctok === undefined">-->
      <!--{{ $route.params.ctok }}-->
      <div style="color: white; font-size: 20px;">{{ $text.tr('ВХОД') }}</div>
      <form @submit.prevent="login">
        <div style="height: 20px;margin-top: 0px; color: indianred; text-align: center;">
          <transition name="fade">
            <span v-if="error">{{ errortxt }}</span>
          </transition>
        </div>
        <i-input v-model="email" type="text" size="large" style="width: 340px; margin-top: 10px;"
               placeholder="email"></i-input><br>
        <!--<input required v-model="email" type="text" placeholder="email"/><br>-->
        <!--<input required v-model="passwd" type="password" placeholder="пароль"/>-->
        <i-input v-model="passwd" type="password" size="large" style="width: 340px; margin-top: 10px;"
               :placeholder="$text.tr('пароль')"></i-input><br><br><br>

        <i-input v-if="tfa || devcode" v-model="tfacode" :disabled="tfacode.length > 5" type="text" size="large" style="width: 340px;"
                 :placeholder="tfa ? $text.tr('2fa код из приложения') : $text.tr('введите код из email')"></i-input>
        <Button v-if="!tfa && !devcode" size="large" long style="width: 340px;" html-type="submit">{{ $text.tr('Войти') }}</Button>
        <!--<button type="submit">Войти</button>-->
      </form>
      <div style="margin-top: 15px; ">
<!--        <div style="text-align: left; padding-left: 15px; width: 170px; color: azure; font-size: 12px;display:inline-block;"><router-link to="/signup">{{ $text.tr('Зарегистрироваться') }}</router-link></div>-->
        <div style="text-align: left; padding-left: 15px; width: 170px; color: azure; font-size: 12px;display:inline-block;"><a href="/app/signup">{{ $text.tr('Зарегистрироваться') }}</a></div>
        <div style="text-align: right; margin-right: 15px; width: 170px; color: azure; font-size: 12px;display:inline-block;"><a href="/app/forgot">{{ $text.tr('Забыли пароль?') }}</a></div>
      </div>

    </div>
  </div>
</template>

<script>
import { sha256 } from 'js-sha256'
import terminal from '@/services/terminal'
import Constants from '@/util/constants'
import Util from '@/util/util'
import Api from '@/util/api'
import MobileDetect from 'mobile-detect'
import Apis from '@/util/apis'

export default {
  name: 'Login',
  data: function () {
    return {
      email: '',
      passwd: '',
      error: false,
      errortxt: '',
      tfa: false,
      tfacode: '',
      devcode: false,
      devcodenum: ''
      // mobile: false
    }
  },
  watch: {
    tfacode (code) {
      if (code.length > 5) {
        this.login()
      }
    }
  },
  created () {
    // var md = new MobileDetect(window.navigator.userAgent)

    // console.log(this.$route.params.ctok)
    if (!this.$route.params.ctok) {
      // if (md.mobile()) {
      //   this.mobile = true
      // }
    } else {
      Api
        .get('confirm?ctok=' + this.$route.params.ctok)
        .then(async (response) => {
          // console.log(response.data)
          if (response.data.err !== undefined) {
            this.$Message.error(this.$text.tr('Ошибка') + ': ' + Util.returnTextForErr(response.data.err))
          } else {
            // if (md.mobile()) {
            //   this.mobile = true
            //   return
            // }

            const tok = response.data.tkn
            const devtkn = response.data.devtkn
            this.$store.state.sys.token = tok
            localStorage.setItem('token', tok)
            // this.$store.state.sys.devtkn = devtkn
            Api
              .get('user/info?token=' + tok + '&demo=1')
              .then(response => {
                // console.log(response)
                this.$store.commit('setDemoState', true)

                // enable CONSTRUCTOR mode by default
                this.$store.state.trade.showTV = true
                this.$store.state.sys.isConstructorModeAllowed = true
                localStorage.setItem('capico_app_showTV', 'true')
                localStorage.setItem('isConstructorModeAllowed', 'true')

                this.$store.state.sys.email = response.data.Email
                localStorage.setItem('email', this.$store.state.sys.email)

                this.$store.state.sys.allexchanges = response.data.exchanges
                this.$store.state.sys.exchanges = []
                response.data.exchanges.forEach(exch => {
                  if (exch.Demo === this.$store.state.sys.demo) {
                    this.$store.state.sys.exchanges.push(exch)
                  }
                })

                localStorage.setItem(response.data.Email + '-devtkn', devtkn)
                this.$router.replace('/terminal')
              })
              .catch(error => {
                console.log(error.response)
                this.$Message.error(this.$text.tr('Ошибка') + ': ' + Util.returnTextForErr(error.response))
              })
          }
        })
        .catch(error => {
          console.log(error.response)
          this.$Message.error(this.$text.tr('Ошибка') + ': ' + Util.returnTextForErr(error.response))
        })
      // console.log('req done')
    }
  },
  methods: {
    async login () {
      try {
        const emailFmt = this.email.trim().toLowerCase()
        const pwdtoken = sha256(emailFmt + sha256(this.passwd))
        let response
        if (this.devcode) {
          response = await terminal.terminalAuthDevcode(pwdtoken, this.devcodenum ? this.devcodenum : this.tfacode, this.devcodenum ? this.tfacode : '')
        } else {
          const devtkn = localStorage.getItem(emailFmt + '-devtkn')
          response = await terminal.terminalAuth(pwdtoken, this.tfacode, devtkn)
        }
        if (response.status === Constants.http.OK) {
          // console.log('ok. data: ', response.data)
          if (response.data.err) {
            if (response.data.err === 'code required') {
              if (this.tfacode) {
                this.devcodenum = this.tfacode
                this.tfacode = ''
              }
              this.tfa = true
            } else if (response.data.err === 'devcode required') {
              this.$Notice.warning({
                title: this.$text.tr('Логин с нового устройства или IP'),
                desc: this.$text.tr('Код выслан на email'),
                duration: 10
              })
              this.devcode = true
            } else if (response.data.err === 'wrong devcode') {
              this.tfacode = ''
              this.error = true
              this.errortxt = this.$text.tr('Неверный код из email')
              setTimeout(() => {
                this.error = false
              }, 3000)
            } else if (response.data.err === 'wrong code') {
              this.tfacode = ''
              this.error = true
              this.errortxt = this.$text.tr('Неверный код 2fa')
              setTimeout(() => {
                this.error = false
              }, 3000)
            } else {
              this.error = true
              this.errortxt = this.$text.tr('Неверный логин или пароль')
              setTimeout(() => {
                this.error = false
              }, 3000)
            }
          } else {
            // success
            this.$store.state.trade.editTrade = null
            // this.$store.state.trade.showTV = false
            this.$store.state.sys.token = response.data.tkn
            localStorage.setItem('token', response.data.tkn)
            if (response.data.devtkn) {
              // this.$store.state.sys.devtkn = response.data.devtkn
              localStorage.setItem(emailFmt + '-devtkn', response.data.devtkn)
            }
            this.getUserInfo()
          }
        } else {
          this.error = true
          this.errortxt = this.$text.tr('Ошибка сети')
          console.log('error. status: ', response.status)
        }
      } catch (error) {
        console.log(error)
      }
    },
    async getUserInfo () {
      const params = {
        params: {
          token: this.$store.state.sys.token,
          demo: this.$store.state.sys.demo ? '1' : '0'
        }
      }
      Api.get('user/info', params).then(async response => {
        if (response.status === Constants.http.OK) {
          this.$store.state.sys.email = response.data.Email
          localStorage.setItem('email', this.$store.state.sys.email)

          try {
            const respsg = await Apis.sg.get('user/info', params)
            if (respsg.status === Constants.http.OK) {
              respsg.data.exchanges.forEach(exch => {
                exch.sptnk = 'sg'
                response.data.exchanges.push(exch)
              })
            }
            response.data.exchanges.sort((a, b) => (a.Name.toLowerCase() < b.Name.toLowerCase()) ? -1 : ((b.Name.toLowerCase() > a.Name.toLowerCase()) ? 1 : 0))
          } catch (err) {
            console.log(err)
          }

          this.$store.state.sys.allexchanges = response.data.exchanges
          this.$store.state.sys.exchanges = []
          response.data.exchanges.forEach(exch => {
            if (exch.Demo === this.$store.state.sys.demo) {
              this.$store.state.sys.exchanges.push(exch)
            }
          })

          this.$store.state.sys.lang = response.data.Lang
          this.$router.push('/terminal')
          this.devcode = false
          this.tfa = false
          this.devcodenum = ''
          this.tfacode = ''
        } else {
          console.log('error. status,data: ', status, response.data)
        }
      }).catch(error => {
        console.log(error)
      })
    },
    loginOLD () {
      const tok = sha256(this.email + sha256(this.passwd))
      // console.log('new token: ', tok)
      Api
        .get('user/info?token=' + tok + (this.$store.state.sys.demo ? '&demo=1' : ''))
        .then(response => {
          // console.log(response)
          // this.$store.state.sys.token = tok
          // localStorage.setItem('token', tok)
          this.$store.state.sys.email = response.data.Email
          this.$store.state.sys.exchanges = response.data.exchanges
          this.$router.push('/terminal')
        })
        .catch(error => {
          console.log(error.response)
          console.log(error)
          this.error = true
          setTimeout(() => {
            this.error = false
          }, 3000)
        })

      /*
      if (this.email === '1' && this.passwd === '1') {
        this.error = false

        // this.$store.state.token = ''
        // localStorage.setItem('token')
        this.$router.push('/')
      } else {
        var tok = sha256(this.email + this.passwd)
        */
    }
  }
}
</script>
